import { Grid } from "@mui/material";
import { ManageSubscriptionsTable } from "@src/components/BillingPanel/components/ManagePlans/components/ManageSubscriptionsTable/ManageSubscriptionsTable";

interface ManagePlansProps {
  showAll?: boolean;
}
export const ManagePlans = ({ showAll }: ManagePlansProps) => {
  return (
    <Grid container item rowSpacing={2} id={"manage-plans"}>
      <ManageSubscriptionsTable showAll={showAll} />
    </Grid>
  );
};
